
export default {
    name: 'SvgKingpinLandingGear',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
